<template>
  <div class="columns is-multiline is-paddingless mgt-5px">
    <qd-collapse class="card transparentCardNoBorder column is-12 pdv-0"
                v-for="(menu, index) of menuAndSubMenu" :key="index"
                :open="indexSubMenuOpen === index"
                @open="setIndexSubMenu(index)" animation="fade">
      <div slot="trigger" slot-scope="props"
           @click="changeMenu(menu)"
           class="card-header disableBoxShadow hoverInMenu" role="button">
        <div class="columns is-marginless card-header-title has-text-white
                pdl-0 level"
             :class="[{'pdr-0 pdv-0'
             : menu.noSubMenu},
             { 'active-router backgroundActiveSubMenu' : activeSubMenu === menu.title
             && menu.noSubMenu }]">
          <span v-if="!menu.noSubMenu"
                class="mgl-15px is-fullwidth has-text-white">
            {{ $t(menu.title) }}
          </span>
          <router-link class="column mgl-15px pdl-0"
                       v-else
                       :class="[
                           { 'text-access-no-permission' : !checkPermissions(menu.perm) },
                           { 'has-permission' : checkPermissions(menu.perm) }
                           ]"
                       :to="{ name: menu.path, params: menu.params }">
            {{ $t(menu.title) }}
          </router-link>
          <b-icon icon="chevron-right" class="level-right animationChevron"
                  :class="[{'rotationChevronOuvertureMenu': props.open },
                  { 'is-invisible' : menu.noSubMenu}]">
          </b-icon>
        </div>
      </div>
      <div class="card-content is-paddingless">
        <div class="content hoverInMenu">
          <div v-for="(subMenu) of menu.data" :key="subMenu.name"
               class="columns is-marginless "
               :class="{'backgroundActiveSubMenu' : activeSubMenu === subMenu.name}"
               @click="changeSubMenu(subMenu.name, subMenu.perm)">
            <router-link class="column pdl-0 mgl-20px border-transparent-5"
                         :class="[
                           { 'active-router' : activeSubMenu === subMenu.name },
                           { 'text-access-no-permission' : !checkPermissions(subMenu.perm) },
                           { 'has-permission' : checkPermissions(subMenu.perm) }
                           ]"
                         :to="{ name: subMenu.path, params: subMenu.params }">
              {{ $t(subMenu.name) }}
            </router-link>
          </div>
        </div>
      </div>
    </qd-collapse>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import { SET_ACTIVE_SUB_MENU, SET_INDEX_SUB_MENU_OPEN } from '@/store/modules/menu/menu-mutation-type';

const Permissions = createNamespacedHelpers('permissions');
const menu = createNamespacedHelpers('menu');

export default {
  name: 'displayMenuAndSubMenu',
  props: {
    menuAndSubMenu: {
      type: Array,
      required: true,
    },
  },
  computed: {
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...menu.mapGetters({
      indexSubMenuOpen: 'indexSubMenuOpen',
      activeSubMenu: 'activeSubMenu',
    }),
  },
  methods: {
    changeMenu(menu) {
      if (!menu.noSubMenu) return;
      this.changeSubMenu(menu.title, menu.perm);
    },
    changeSubMenu(nomSubMenu, perm) {
      if (this.checkPermissions(perm)) {
        this.setActiveSubMenu(nomSubMenu);
      }
    },
    ...menu.mapMutations({
      setIndexSubMenu: SET_INDEX_SUB_MENU_OPEN,
      setActiveSubMenu: SET_ACTIVE_SUB_MENU,
    }),
  },
};
</script>

<style scoped>

</style>
